import { Toaster as HotToaster, toast } from 'react-hot-toast';

export function Toaster() {
  return (
    <HotToaster
      position="bottom-right"
      toastOptions={{
        duration: 3000,
        style: {
          background: '#1E293B',
          color: '#F8FAFC',
          border: '1px solid #334155',
        },
        success: {
          iconTheme: {
            primary: '#10B981',
            secondary: '#F8FAFC',
          },
        },
        error: {
          iconTheme: {
            primary: '#EF4444',
            secondary: '#F8FAFC',
          },
        },
      }}
    />
  );
}

// Re-export toast so callers don't need a direct dependency on react-hot-toast.
export { toast };